import { Box, BoxProps } from '@mantine/core'
import chunk from 'lodash/chunk'
import { useIsMobile } from 'hooks/useIsMobile'
import { HealthTool } from 'interfaces/types'
import { Card } from './card'
import useStyles from './index.styles'

export type HealthToolTypeCategoryProps = {
  healthTools: HealthTool[]
} & BoxProps

const HealthToolTypeCategory = ({
  healthTools,
  styles,
  className,
  classNames,
  ...boxProps
}: HealthToolTypeCategoryProps) => {
  const isMobile = useIsMobile()
  const healthToolSegments = chunk(healthTools, isMobile ? 4 : 9)
  const { classes } = useStyles(undefined, {
    name: 'HealthToolTypeCategory',
    styles,
    classNames,
  })

  if (healthTools?.length === 0) return <></>

  return healthTools?.length !== 0 ? (
    <Box {...boxProps}>
      {healthToolSegments.map((segment) =>
        segment.map((tool, index) => (
          <Card tool={tool} key={`${index}-mobile`} className={classes.card} />
        )),
      )}
    </Box>
  ) : null
}

export { HealthToolTypeCategory }
